var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_ppt_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139154",
    "data-name": "\\uD328\\uC2A4 139154",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139155",
    "data-name": "\\uD328\\uC2A4 139155",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139156",
    "data-name": "\\uD328\\uC2A4 139156",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.922.922,0,0,1,.269.269.9.9,0,0,1,.91,0H27.076a.91.91,0,0,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.805 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139157",
    "data-name": "\\uD328\\uC2A4 139157",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139158",
    "data-name": "\\uD328\\uC2A4 139158",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139159",
    "data-name": "\\uD328\\uC2A4 139159",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139160",
    "data-name": "\\uD328\\uC2A4 139160",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#e63950"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139161",
    "data-name": "\\uD328\\uC2A4 139161",
    d: "M6.263,42.47H.926A.926.926,0,0,1,0,41.544V.926A.926.926,0,0,1,.926,0H6.262a.926.926,0,0,1,.926.926V41.544A.925.925,0,0,1,6.263,42.47Z",
    transform: "translate(16.78 34.247)",
    fill: "#e8566f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139162",
    "data-name": "\\uD328\\uC2A4 139162",
    d: "M6.262,28.664H.926A.926.926,0,0,1,0,27.738V.926A.926.926,0,0,1,.926,0H6.262a.926.926,0,0,1,.926.926V27.738A.926.926,0,0,1,6.262,28.664Z",
    transform: "translate(30.807 48.053)",
    fill: "#b7022d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139163",
    "data-name": "\\uD328\\uC2A4 139163",
    d: "M6.262,49.768H.926A.926.926,0,0,1,0,48.842V.926A.926.926,0,0,1,.926,0H6.262a.926.926,0,0,1,.926.926V48.842A.926.926,0,0,1,6.262,49.768Z",
    transform: "translate(58.86 26.949)",
    fill: "#b7022d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139164",
    "data-name": "\\uD328\\uC2A4 139164",
    d: "M6.262,38.651H.926A.926.926,0,0,1,0,37.725V.926A.926.926,0,0,1,.926,0H6.262a.926.926,0,0,1,.926.926v36.8A.926.926,0,0,1,6.262,38.651Z",
    transform: "translate(44.834 38.066)",
    fill: "#e8566f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139376",
    "data-name": "\\uD328\\uC2A4 139376",
    d: "M2.274,6.849v3.535H0V0H3.928A4.884,4.884,0,0,1,6.994.823,2.879,2.879,0,0,1,8.041,3.232,3.28,3.28,0,0,1,6.884,5.867a4.505,4.505,0,0,1-3.018.982ZM2.26,1.633V5.2h.606A3.736,3.736,0,0,0,5.13,4.73a1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42ZM12.1,6.849v3.535H9.829V0h3.928a4.884,4.884,0,0,1,3.066.823,2.879,2.879,0,0,1,1.047,2.408,3.28,3.28,0,0,1-1.158,2.636,4.505,4.505,0,0,1-3.018.982Zm-.014-5.216V5.2H12.7a3.736,3.736,0,0,0,2.264-.472,1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42Zm15.548.09H24.227v8.661H21.953V1.723H18.542V0h9.1Z",
    transform: "translate(8.817 9.441)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaPptIcon);
export default __webpack_public_path__ + "static/media/minerva_ppt_icon.afa7f38fb934e782d9df214dc925d274.svg";
export { ForwardRef as ReactComponent };